export const SELECT_SUBMENU = 'SELECT_SUBMENU';
export const ACTIVE_MENU = 'ACTIVE_MENU';
export const ACTIVE_MENU_PARENT = 'ACTIVE_MENU_PARENT';
export const ACTIVE_MENU_NAME = 'ACTIVE_MENU_NAME';
